import React, { Component } from 'react';
import styles from './SelectBox.module.css';
import { Input } from 'reactstrap';
import { restructureResponse } from '../../helpers/sparql';

class SelectBox extends Component {
  componentDidMount() {
    if (this.props.data) {
      try{
      let item = restructureResponse(this.props.data)[0];
      let keyURI = this.props.data.head.vars[0];
      let value = item[keyURI];
      this.props.publish(this.props.publishVariable, value);
      }
      catch(e) 
      {
        console.log(e);
      }
    }
  }

  onChange = event => {
    let value = event.target.value;
    console.log(value);
    this.props.publish(this.props.publishVariable, value);
  };

  render() {
    if (!this.props.data) return null;
    let headVars = this.props.data.head.vars;
    let keyURI = headVars[0]; // graph
    let keyLabel = headVars[1]; // label
    let items = restructureResponse(this.props.data);
    let value = this.props.pubsub[this.props.publishVariable];

    return (
      <div className={styles.main}>
        <div className={styles.label}>{this.props.label}</div>
        <Input value={value || ''} type="select" onChange={this.onChange}>
          {/* <option value="">Kies een {this.props.publishVariable}...</option> */}
          {items.map(item => (
            <option key={item[keyURI]} value={item[keyURI]}>
              {item[keyLabel]}
            </option>
          ))}
        </Input>
      </div>
    );
  }
}

export default SelectBox;
